import React from 'react'
import { Form, Select } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import { MultiSelectQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'

const Container = styled.div`
  margin: 16px 0;
`

function MultiSelectQuestion({
  field,
  formFieldName,
  layout,
  disabled = false,
  required = false,
  customRules = [],
  customOptions,
  placeholder = 'Type or select an option',
  loading = false
}: MultiSelectQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = field?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  // Use custom options if provided, otherwise fall back to field answerOptions
  const options =
    customOptions ||
    field.answerOption?.map((option) => ({
      label: option?.valueCoding?.display,
      value: option?.valueCoding?.code ?? option?.valueCoding?.display ?? ''
    }))

  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <Select
              mode="multiple"
              disabled={disabled}
              placeholder={placeholder}
              options={options}
              loading={loading}
              showSearch
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default MultiSelectQuestion
